import { render, staticRenderFns } from "./SkypeIcon.vue?vue&type=template&id=a684f238&scoped=true"
import script from "./SkypeIcon.vue?vue&type=script&lang=js"
export * from "./SkypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a684f238",
  null
  
)

export default component.exports